"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.function.name.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.enhancer = exports.EnhancerContext = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _client = require("@apollo/client");

var _Apps = _interopRequireDefault(require("@meepshop/context/lib/Apps"));

var _Currency = _interopRequireDefault(require("@meepshop/context/lib/Currency"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _Role = _interopRequireDefault(require("@meepshop/context/lib/Role"));

var _useCart2 = _interopRequireDefault(require("@meepshop/hooks/lib/useCart"));

var _link = require("@meepshop/link");

var _filter = _interopRequireDefault(require("@meepshop/utils/lib/filter"));

var _withContext = _interopRequireDefault(require("@store/utils/lib/withContext"));

var _useCart3 = require("@meepshop/hooks/lib/gqls/useCart");

var _isLogin = require("../constants/isLogin");

var _decoratorsRoot = require("./gqls/decoratorsRoot");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var EnhancerContext = /*#__PURE__*/_react["default"].createContext({});

exports.EnhancerContext = EnhancerContext;
var enhancer = (0, _withContext["default"])(EnhancerContext);
exports.enhancer = enhancer;

var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _data$viewer, _data$viewer$store, _data$viewer2, _data$viewer2$store, _data$viewer3, _data$viewer3$store, _data$viewer3$store$d, _data$viewer4, _data$viewer4$store, _data$viewer4$store$l, _data$viewer4$store$l2, _data$viewer5, _data$viewer5$store, _data$viewer5$store$m, _data$viewer5$store$m2, _data$viewer6, _data$viewer6$store, _data$getStockNotific, _data$viewer7, _data$viewer7$store, _data$viewer8, _data$viewer8$store;

  var children = _ref.children;

  var _useQuery = (0, _client.useQuery)(_decoratorsRoot.getContextData),
      data = _useQuery.data;

  var router = (0, _link.useRouter)();

  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  var apps = (0, _react.useContext)(_Apps["default"]);

  var _useContext2 = (0, _react.useContext)(_Currency["default"]),
      c = _useContext2.c;

  var role = (0, _react.useContext)(_Role["default"]);

  var _useCart = (0, _useCart2["default"])((0, _filter["default"])(_useCart3.useCartFragment, (data === null || data === void 0 ? void 0 : data.viewer) || null)),
      loading = _useCart.loading,
      cartItems = _useCart.cartItems,
      upsertCart = _useCart.upsertCart;

  return /*#__PURE__*/_react["default"].createElement(EnhancerContext.Provider, {
    value: {
      /** context variables from props */
      cname: (data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : (_data$viewer$store = _data$viewer.store) === null || _data$viewer$store === void 0 ? void 0 : _data$viewer$store.cname) || '',
      storeSetting: _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : (_data$viewer2$store = _data$viewer2.store) === null || _data$viewer2$store === void 0 ? void 0 : _data$viewer2$store.setting), {}, {
        storeName: (data === null || data === void 0 ? void 0 : (_data$viewer3 = data.viewer) === null || _data$viewer3 === void 0 ? void 0 : (_data$viewer3$store = _data$viewer3.store) === null || _data$viewer3$store === void 0 ? void 0 : (_data$viewer3$store$d = _data$viewer3$store.description) === null || _data$viewer3$store$d === void 0 ? void 0 : _data$viewer3$store$d.name) || '',
        logoUrl: (data === null || data === void 0 ? void 0 : (_data$viewer4 = data.viewer) === null || _data$viewer4 === void 0 ? void 0 : (_data$viewer4$store = _data$viewer4.store) === null || _data$viewer4$store === void 0 ? void 0 : (_data$viewer4$store$l = _data$viewer4$store.logoImage) === null || _data$viewer4$store$l === void 0 ? void 0 : (_data$viewer4$store$l2 = _data$viewer4$store$l.scaledSrc) === null || _data$viewer4$store$l2 === void 0 ? void 0 : _data$viewer4$store$l2.h200) || '',
        mobileLogoUrl: (data === null || data === void 0 ? void 0 : (_data$viewer5 = data.viewer) === null || _data$viewer5 === void 0 ? void 0 : (_data$viewer5$store = _data$viewer5.store) === null || _data$viewer5$store === void 0 ? void 0 : (_data$viewer5$store$m = _data$viewer5$store.mobileLogoImage) === null || _data$viewer5$store$m === void 0 ? void 0 : (_data$viewer5$store$m2 = _data$viewer5$store$m.scaledSrc) === null || _data$viewer5$store$m2 === void 0 ? void 0 : _data$viewer5$store$m2.w250) || '',
        shippableCountries: (data === null || data === void 0 ? void 0 : (_data$viewer6 = data.viewer) === null || _data$viewer6 === void 0 ? void 0 : (_data$viewer6$store = _data$viewer6.store) === null || _data$viewer6$store === void 0 ? void 0 : _data$viewer6$store.shippableCountries) || []
      }),
      isLogin: role === 'SHOPPER' ? _isLogin.ISUSER : _isLogin.NOTLOGIN,
      user: (data === null || data === void 0 ? void 0 : data.viewer) || null,
      stockNotificationList: (data === null || data === void 0 ? void 0 : (_data$getStockNotific = data.getStockNotificationList) === null || _data$getStockNotific === void 0 ? void 0 : _data$getStockNotific.data) || [],
      colors: colors,
      hasStoreAppPlugin: function hasStoreAppPlugin(pluginName) {
        return apps[pluginName].isInstalled;
      },
      transformCurrency: c,
      carts: cartItems,
      cartLoading: loading,
      upsertCart: upsertCart
    }
  }, children({
    // 團購頁面隱藏頁腳
    hiddingMeepshopMaxInFooterEnabled: router.pathname === '/events/group-buy/[eventId]' || (data === null || data === void 0 ? void 0 : (_data$viewer7 = data.viewer) === null || _data$viewer7 === void 0 ? void 0 : (_data$viewer7$store = _data$viewer7.store) === null || _data$viewer7$store === void 0 ? void 0 : _data$viewer7$store.hiddingMeepshopMaxInFooterEnabled),
    cname: (data === null || data === void 0 ? void 0 : (_data$viewer8 = data.viewer) === null || _data$viewer8 === void 0 ? void 0 : (_data$viewer8$store = _data$viewer8.store) === null || _data$viewer8$store === void 0 ? void 0 : _data$viewer8$store.cname) || ''
  }));
});

exports["default"] = _default;